export const APP_INIT = 'app:INIT';
export const APP_SET_ERROR = 'app:SET_ERROR';
export const APP_SET_READY = 'app:SET_READY';
export const APP_SET_PROVISIONS = 'app:SET_PROVISIONS';
export const APP_SET_SETTINGS = 'app:APP_SET_SETTINGS';
export const CP_INIT = 'cp:INIT';

export const CUSTOM_PARAMS_SET_STATE = 'customParams:SET_STATE';
export const CUSTOM_PARAMS_UPDATE_STATE = 'customParams:UPDATE_STATE';
export const CUSTOM_PARAMS_SET_VALUE = 'customParams:CUSTOM_PARAMS_SET_VALUE';
export const CUSTOM_PARAMS_FETCH = 'customParams:CUSTOM_PARAMS_FETCH';
export const CUSTOM_PARAMS_FAILED = 'customParams:CUSTOM_PARAMS_FAILED';
export const CUSTOM_PARAM_CHANGED = 'customParams:CUSTOM_PARAM_CHANGED';

export const HOSTING_ELEMENT_CHANGED = 'embeddedForm:HOSTING_ELEMENT_CHANGED';
export const INIT_HOSTING_ELEMENT = 'embeddedForm:INIT_HOSTING_ELEMENT';
